import * as React from 'react';
import { Form, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { flow } from 'lodash';
import { Button } from 'react-bootstrap';
import {IPolicyApplication, IProduct} from '../../../../data/api/models';
import FaChevronRight from 'react-icons/fa/chevron-right';

import TravellersInfo from './components/TravellersInfo';
import {connect} from 'react-redux';
import {actions as quoteActions} from '../../../../services/quote/reducer';
import {bindActionCreators} from 'redux';
import {IStore} from '../../../../redux/IStore';
import {II18nMessages} from '../../../../services/branding/models';

interface IPersonalDetailsProps {
  onBack: () => void;
  handleSubmit: () => void;
  change: any;
  product: IProduct;
  i18n: II18nMessages;
  groupType: string;
  channel: any;
  dispatch: any;
}

class PersonalDetails extends React.Component<IPersonalDetailsProps> {

  public componentWillMount() {
    const { dispatch, change } = this.props;

    dispatch(change('emailSend', false));
  }

  public render() {
    const { handleSubmit, onBack, product, i18n, groupType, channel } = this.props;
    return (
      <Form onSubmit={handleSubmit} autoComplete="off">
        <div className="steps-container">
          <div className="section-title">
            <h1>Personal details</h1>
          </div>
          <strong>Please complete all fields below.</strong>
          <FieldArray
            name="travellers"
            i18n={i18n}
            channel={channel}
            product={product}
            test={'test'}
            component={TravellersInfo}
            groupType={groupType}
            change={this.props.change}
          />

          <div className="btn-bar margin-top">
            <Button
              bsStyle="primary"
              type="submit"
              className="pull-right"
              // disabled={submitting || (submitFailed && !valid)}
            >
                Continue
              <FaChevronRight/>
            </Button>
            <Button type="button" className="btn-back" onClick={onBack}>
              Back
            </Button>
          </div>

        </div>
      </Form>
    );
  }
}

let selector;
let previousValues;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onChange: (
      values: IPolicyApplication,
      dispatch,
      props: IPersonalDetailsProps,
    ) => {
      if (! previousValues) {
        previousValues = values;
        return;
      }

      const recalculateScore = false;
      previousValues = values;
    },
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');
      const groupType = selector(state, 'groupType');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const destinationsValue = selector(state, 'destinations');
      const occupationValue = selector(state, 'occupations');
      const industryValue = selector(state, 'industries');
      const region = selector(state, 'region');
      const maxTripDuration = selector(state, 'maxTripDuration');
      const residency = selector(state, 'residency');
      const quotationTypes = selector(state, 'quotationTypes');

      return {
        tripType,
        quotationTypes,
        residency,
        region,
        maxTripDuration,
        groupType,
        startDate,
        endDate,
        destinationsValue,
        occupationValue,
        industryValue,
        auth: state.auth,
        channel: state.branding.channel,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(PersonalDetails);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/PersonalDetails/index.tsx